import { render, staticRenderFns } from "./GaleriaPar.vue?vue&type=template&id=7d29459e&scoped=true&"
import script from "./GaleriaPar.vue?vue&type=script&lang=js&"
export * from "./GaleriaPar.vue?vue&type=script&lang=js&"
import style0 from "./GaleriaPar.vue?vue&type=style&index=0&id=7d29459e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d29459e",
  null
  
)

export default component.exports